import Vue from "vue";
import Vuex from "vuex";
import { leftLikeDicts } from "@/api/system";
import { treeselect } from "@/api/menu";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dicts: {},
    menuList: [],
  },
  mutations: {
    setDicts(state, payload) {
      // 将payload数组转换为以dictKey为key的对象，方便通过key取value
      const dictObj = {};
      payload.forEach((arr) => {
        if (Array.isArray(arr) && arr.length > 0) {
          const item = arr[0];
          dictObj[item.dictKey] = item.dictValue;
        }
      });
      state.dicts = dictObj;
      document.title = dictObj["title"];
    },
    setMenuList(state, menuList) {
      state.menuList = menuList;
    },
  },
  actions: {
    async fetchDicts({ commit }) {
      const res = await leftLikeDicts([
        "contact",
        "email",
        "address",
        "icp",
        "follow",
        "bottom_nav",
        "logo",
        "logo_color",
        "title",
      ]);

      if (res && res.data.code === 200) {
        commit("setDicts", res.data.data);
      }
    },
    async fetchMenuList({ commit }) {
      const res = await treeselect();
      if (res.data && res.data.data) {
        function filterHidden(menuList) {
          return menuList
            .filter((menu) => !menu.hidden)
            .map((menu) => ({
              ...menu,
              children: menu.children ? filterHidden(menu.children) : [],
            }));
        }
        const filteredMenuList = filterHidden(res.data.data);
        filteredMenuList.sort((o1, o2) => o1.orderNum - o2.orderNum);
        commit("setMenuList", filteredMenuList);
      }
    },
  },
  getters: {
    getDicts: (state) => state.dicts,
    getMenuList: (state) => state.menuList,
  },
});
